import * as React from 'react';
import './ActionButtons.css';

export interface ActionButtonsProps {
  isProcessing: boolean;
  isSaveDisabled: boolean;
  onSave: () => void;
  onCancel: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isProcessing,
  isSaveDisabled,
  onSave,
  onCancel,
}) => {
  return (
    <div className="button-group">
      <button
        className="btn-primary"
        onClick={onSave}
        disabled={isSaveDisabled}
      >
        <span className="material-icons-round">save</span>
        {isProcessing ? 'Bezig...' : 'Opslaan'}
      </button>
      <button
        className="btn-secondary"
        onClick={onCancel}
        disabled={isProcessing}
      >
        <span className="material-icons-round">close</span>
        Annuleren
      </button>
    </div>
  );
};

export default ActionButtons;
